import { fridayAgent } from '@cvte/react-fridayagent3';

export interface BaseTracker {
  code: string;
  name?: string;
  data?: object;
}

class Friday {
  protected staff = { orgName: '', orgId: '', orgCode: '', userId: '' };

  public setStaffInfo = (staff: any) => {
    this.staff = staff;
    console.log('Friday -->', this.staff);
  };

  /**
   * 埋点上报
   */
  public pushData(tracker: BaseTracker) {
    const { orgId = '', orgCode = '', orgName = '', userId = '' } = this.staff || {};
    // 添加user信息,绑定Friday $tid 属性 文档说明[https://kb.cvte.com/display/DocTechShare/Friday-JS-SDK]
    //     fridayAgent.setUser({ id: userId });
    fridayAgent.pushData({
      ...tracker,
      data: {
        ...(tracker.data || {}),
        id: userId,
        user_id: userId,
        org_id: orgId,
        org_code: orgCode,
        org_name: orgName
      }
    });
  }

  public report = this.pushData.bind(this);
}

const friday = new Friday();

export default friday;
